import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import i18n from "./i18n";
import "./sass/main.scss";

// Import Sweetalert2
import VueSweetalert2 from "vue-sweetalert2";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

import {
  library
} from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

/* import specific icons */
import {
  faExclamationCircle,
  faChevronLeft
} from '@fortawesome/free-solid-svg-icons'

import LottieAnimation from 'lottie-web-vue';

// Import FilePond
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
/* add icons to the library */
library.add(faExclamationCircle, faChevronLeft)

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

Vue.use(LottieAnimation);
Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

Vue.use(VueSweetalert2);

// importt components
Vue.component("file-pond", FilePond);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)
